<template>
<div class="backoffice-messages">
    <div class="page-header">
        <div class="left">
            <h2 class="page-title">{{ $page.props.lang.title || "Messages" }}</h2>
        </div>
        <div class="right">
            <span class="mr-2"><b>{{ $page.props.lang.sms_credit || "SMS Credit" }}: {{sms_credit | round(2)}}</b></span>
        <v-menu>
            <template v-slot:activator="{ attrs, on }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small>mdi-plus</v-icon>
                <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newMessage || "New message" }}</span>
                </v-btn>
            </template>
            <v-list>
                <v-list-item link @click="smsModal = true"> 
                    <v-list-item-title>SMS</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="emailModal = true">
                    <v-list-item-title>E-mail</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        </div>
        <v-dialog v-model="detailsModal" max-width="500px">
            <v-card>
                <div class="header-messages-details">
                    <h4 class="modal-headline">{{ $page.props.lang.message_details || "Message details" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="detailsModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-tabs v-model="tab" color="primary" fixed-tabs>
                <v-tab><v-icon left small>mdi-filter-variant</v-icon>{{ $page.props.lang.recipients_list || "Recipients list" }}</v-tab>
                <v-tab><v-icon left small>mdi-message-outline</v-icon>{{ $page.props.lang.message_tab || "Message" }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" style="height:400px;overflow-y: auto;">
                    <v-tab-item>
                        <v-card flat>
                            <div class="table-container">
                                <v-data-table
                                class="ml-1 mr-1"
                              
                                :headers="detailsHeaders"
                                :items="currentMessage.recipients"
                                mobile-breakpoint="0"
                               >
                                    <template v-slot:item.full_name="{ item }">
                                        <v-avatar size="28"> 
                                            <img :src="item.member.profile_photo_url + '?w=80'" alt="">
                                        </v-avatar>
                                        {{ item.member.full_name }}
                                    </template>
                                    <template v-slot:item.created_at="{ item }">
                                        {{ item.created_at | fullDate }}
                                    </template>
                                </v-data-table>
                            </div>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card-text>
                           <p class="font-weight-regular text-subtitle-1" v-html="currentMessage.message"></p>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-dialog>

        <SmsModal
        v-if="smsModal"
        :open="smsModal"
        :sms_credit="sms_credit"
        @close="smsModal = false">
        </SmsModal>

        <EmailModal
        v-if="emailModal"
        :open="emailModal"
        @close="emailModal = false">
        </EmailModal>
    </div>

    <div class="table-container">
            <v-data-table
            :headers="headers"
            :items="campaigns.data"
            :server-items-length="campaigns.total"
            :page="campaigns.current_page"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            mobile-breakpoint="0"
            :footer-props="{
                    'items-per-page-options': [5, 10, 15]
                }"
            >
                <template v-slot:item.created_at="{ item }">
                     {{ item.created_at | fullDate }}
                </template>
                <template v-slot:item.type="{ item }">
                    {{ item.type }}
                </template>
                <template v-slot:item.sent="{ item }">
                    {{ item.target }}
                </template>
                <template v-slot:item.sent_by="{ item }">
                    {{ item.created_by.full_name }}
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn @click="openDetailsModal(item)" :id="'details' + item.id" icon>
                        <v-icon>mdi-information-outline</v-icon>
                        <v-tooltip :activator="'#details'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.details || "Show Details"}}</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn @click="openDeleteModal(item)" :id="'delete' + item.id" class="delete-icon" icon>
                        <v-icon>mdi-trash-can-outline</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.delete || "Delete"}}</span>
                        </v-tooltip>
                </v-btn>
                </template>
            </v-data-table>
            <ConfirmModal 
                :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
                :description="$page.props.lang.delete_confirmation_description || 'If you click YES, the message will be permanently deleted. Are you sure?'" 
                :open="deleteModal" 
                @no="deleteModal = false" 
                @yes="deleteMessage" 
                @close="deleteModal = false">
            </ConfirmModal>
        </div>

        <!-- <pagination :links="campaigns.links" /> -->
</div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import ConfirmModal from '@/js/Components/ConfirmModal'
import SmsModal from './Components/SmsModal'
import EmailModal from './Components/EmailModal'
import EventBus from '@/js/eventbus'
import Pagination from "@/js/Components/Pagination"
import pickBy from 'lodash/pickBy'

export default {

    metaInfo() {
        return {
            title: this.$page.props.lang.title || "Message center"
        }
    },
    layout: AppLayout,
    components: {
        ConfirmModal, 
        SmsModal,
        EmailModal,
        Pagination
    },
    props: {
        campaigns: Object,
        sms_credit: Number,
        lang: Object
    },

    data(){
        return {
            campaignsData: this.campaigns.data,
            options:{page: this.campaigns.current_page},
            tab:null,
            smsModal: false,
            emailModal: false,
            detailsModal: false,
            messageForDeleteId: null,
            currentMessage:{},
            deleteModal: false,
            headers: [
                {text: this.lang.table_send_at || 'Sent at', value: 'created_at', align: 'start', sortable: false},
                {text: this.lang.table_type || 'Type', value: 'type', sortable: false},
                {text: this.lang.table_sent_to || 'Sent to', value: 'sent', sortable: false},
                {text: this.lang.table_sent_by || 'Sent By', value: 'sent_by', sortable: false},
                {text: '', value: 'action', sortable: false, align: 'right'}
            ],
            detailsHeaders:[
                {text: this.lang.detailTable_name || 'Full name', value: 'full_name', align: 'start', sortable: false},
                {text: this.lang.table_send_at || 'Sent at', value: 'created_at', align: 'center'}
            ]
        }
    },
    watch: {
        options:{
             
             handler (val, oldVal) {
                
                if(val.page != oldVal.page || val.itemsPerPage != oldVal.itemsPerPage){

                    let data = {}
            
                    data.page = val.page;
                    data.items_per_page = this.options.itemsPerPage;
              
                    this.$inertia.get('/backoffice/messages', pickBy(data), {preserveState: true});
                    this.options.page = this.campaigns.current_page; 
                }
              
            },
            deep: true,
        },
    },
    created() {
        
    },
    methods:{
        openDeleteModal(item){
            this.deleteModal = true
            this.messageForDeleteId = item.id
        },

        openDetailsModal(item){
            axios.get('/backoffice/messages/getMessage/'+ item.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.detailsModal = true;
                        this.currentMessage = response.data.campaign;
                    }else{
                        alert(response.data.message)
                    }
                });
        },

        deleteMessage(){
            axios.post('/backoffice/messages/delete', {id: this.messageForDeleteId})
                .then(response => {
                    if (response.data.status==="OK") {
                        this.$inertia.reload()
                       EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {                   
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
                this.deleteModal = false
        }
    }
}
</script>